module.exports = __webpack_public_path__ + "static/media/5.0dcc98bd.png";